import { Injectable } from '@angular/core';
import { NetworkManager } from 'src/app/managers/network/network.manager';
import { HttpHeaders } from '@angular/common/http';
import { RequestField } from 'src/app/enums/network/request/requestField.enum';
import { CQWebappApi } from 'src/app/enums/network/request/cqwebapp/cqwebappApi.enum';

@Injectable({
  providedIn: 'root',
})
export class DeviceRequest {
  constructor(private network: NetworkManager) {}

  /**
   *
   * @param token
   * @param siteId
   * @param type
   */
  list(token: string, siteId: number, type: number, enabled: number) {
    let url = this.network.CodaQApi() + CQWebappApi.DEVICE_LIST;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());
    form.set(RequestField.ENABLED, enabled.toString());

    if (type) form.set(RequestField.TYPE, type.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param deviceId
   */
  detail(token: string, deviceId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.DEVICE_DETAIL;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.DEVICE_ID, deviceId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param deviceId
   * @param data
   */
  update(token: string, deviceId: number, data: string) {
    let url = this.network.CodaQApi() + CQWebappApi.DEVICE_UPDATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.DEVICE_ID, deviceId.toString());
    form.set(RequestField.DATA, data.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param siteId
   * @param data
   *
   */
  create(token: string, siteId: number, data: string) {
    let url = this.network.CodaQApi() + CQWebappApi.DEVICE_CREATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());
    form.set(RequestField.DATA, data.toString());

    return this.network.http().post(url, form.toString(), { headers });
  }

  /**
   * Get device activation
   * @param token
   * @param deviceId
   */
  activation(token: string, deviceId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.DEVICE_ACTIVATION;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.DEVICE_ID, deviceId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param deviceId
   */
  calendar(token: string, deviceId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.DEVICE_CALENDAR;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.DEVICE_ID, deviceId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param deviceId
   * @param calendarId
   * @param timeId
   */
  deleteTime(
    token: string,
    deviceId: number,
    calendarId: number,
    timeId: number,
  ) {
    let url = this.network.CodaQApi() + CQWebappApi.DEVICE_CALENDAR_DELETE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.DEVICE_ID, deviceId.toString());
    form.set(RequestField.CALENDAR_ID, calendarId.toString());
    form.set(RequestField.TIME_ID, timeId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   * @param calendarId
   * @param dow
   * @param open
   * @param close
   */
  updateCalendar(
    token: string,
    deviceId: number,
    calendarId: number,
    dow: number,
    open: string,
    close: string,
  ) {
    let url = this.network.CodaQApi() + CQWebappApi.DEVICE_CALENDAR_UPDATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();

    console.log('-->' + calendarId);

    form.set(RequestField.DEVICE_ID, deviceId.toString());
    form.set(RequestField.CALENDAR_ID, calendarId.toString());
    form.set(RequestField.CALENDAR_DOW, dow.toString());
    form.set(RequestField.CALENDAR_OPEN, open.toString());
    form.set(RequestField.CALENDAR_CLOSE, close.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   * Get service list of specific counter
   * @param token
   * @param siteId
   * @param deviceId
   */
  getDeviceService(token: string, siteId: number, deviceId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.DEVICE_SERVICE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();

    form.set(RequestField.SITE_ID, siteId.toString());
    form.set(RequestField.DEVICE_ID, deviceId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param siteId
   * @param serviceId
   * @param deviceId
   * @param set
   */
  updateDeviceService(
    token: string,
    siteId: number,
    serviceId: number,
    deviceId: number,
    set: number,
  ) {
    let url = this.network.CodaQApi() + CQWebappApi.UPDATE_DEVICE_SERVICE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();

    form.set(RequestField.SITE_ID, siteId.toString());
    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.DEVICE_ID, deviceId.toString());
    form.set(RequestField.SET, set.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param serviceId
   * @param calendarId
   * @param timeId
   * @param enabled
   */
  calendarStatus(
    token: string,
    deviceId: number,
    calendarId: number,
    timeId: number,
    enabled: number,
  ) {
    let url = this.network.CodaQApi() + CQWebappApi.DEVICE_CALENDAR_STATUS;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.DEVICE_ID, deviceId.toString());
    form.set(RequestField.CALENDAR_ID, calendarId.toString());
    form.set(RequestField.TIME_ID, timeId.toString());
    form.set(RequestField.ENABLED, enabled.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }
}
